import Product from './Product.container';

export default Product;
